import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest, withApi } from "../utils/api";

// Todas las IPs (rol games).
export const fetchIps = createAsyncThunk(
    "ips/fetchIps",
    withApi(async (_, { token }) => {
        const data = await apiRequest("/ips", { token });
        return Array.isArray(data) ? data : [];
    })
);

const ipsSlice = createSlice({
    name: "ips",
    initialState: {
        ips: [],
        statusIps: "idle",
        errorips: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchIps.pending, (state) => {
                state.statusIps = "loading";
            })
            .addCase(fetchIps.fulfilled, (state, action) => {
                state.statusIps = "succeeded";
                state.ips = action.payload;
            })
            .addCase(fetchIps.rejected, (state, action) => {
                state.statusIps = "failed";
                state.errorips = action.payload || action.error.message;
            });
    },
});

export default ipsSlice.reducer;
